module.exports = __webpack_public_path__ + "static/media/cat.c173f851.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/cat.jpg
 ** module id = 411
 ** module chunks = 0
 **/